export enum EtatEcriture {
    NON_REGLE, // Non réglé (facture) | Non utilisé (Avoir)
    REGLEE, // Réglée (Facture) | Utilisée (Avoir)
    EN_COURS_DE_REGLEMENT, // En cours de règlement (Facture) | En cours d'utilisation (Avoir)
    PRELEVEMENT_DEMANDE,
    EN_COURS_DE_PRELEVEMENT
}
